export default __webpack_public_path__ + "static/slider2-a85c7f2aaef4b89b7f46a5fe2e9f8124.png";